"use strict";
// Shared logical border property parser
// Handles parsing of CSS logical border properties (border-inline-start, border-inline-end and their components)
// https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_logical_properties_and_values
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseLogicalBorderProperty = parseLogicalBorderProperty;
exports.logicalBorderToCSSValue = logicalBorderToCSSValue;
exports.parseLogicalBorderWidthProperty = parseLogicalBorderWidthProperty;
exports.logicalBorderWidthToCSSValue = logicalBorderWidthToCSSValue;
exports.parseLogicalBorderStyleProperty = parseLogicalBorderStyleProperty;
exports.logicalBorderStyleToCSSValue = logicalBorderStyleToCSSValue;
exports.parseLogicalBorderColorProperty = parseLogicalBorderColorProperty;
exports.logicalBorderColorToCSSValue = logicalBorderColorToCSSValue;
const shared_border_individual_1 = require('./shared-border-individual.cjs');
const shared_border_width_1 = require('./shared-border-width.cjs');
const shared_border_style_1 = require('./shared-border-style.cjs');
const shared_border_color_1 = require('./shared-border-color.cjs');
/**
 * Parse logical border shorthand property value (border-inline-start, border-inline-end)
 * Uses the same syntax as individual border shorthand properties
 */
function parseLogicalBorderProperty(value) {
    return (0, shared_border_individual_1.parseBorderIndividualProperty)(value);
}
/**
 * Convert logical border shorthand value to CSS string
 */
function logicalBorderToCSSValue(parsed) {
    return (0, shared_border_individual_1.borderIndividualToCSSValue)(parsed);
}
/**
 * Parse logical border width property value (border-inline-start-width, border-inline-end-width)
 * Uses the same syntax as individual border width properties
 */
function parseLogicalBorderWidthProperty(value) {
    return (0, shared_border_width_1.parseBorderWidthProperty)(value);
}
/**
 * Convert logical border width value to CSS string
 */
function logicalBorderWidthToCSSValue(parsed) {
    return (0, shared_border_width_1.borderWidthToCSSValue)(parsed);
}
/**
 * Parse logical border style property value (border-inline-start-style, border-inline-end-style)
 * Uses the same syntax as individual border style properties
 */
function parseLogicalBorderStyleProperty(value) {
    return (0, shared_border_style_1.parseBorderStyleProperty)(value);
}
/**
 * Convert logical border style value to CSS string
 */
function logicalBorderStyleToCSSValue(parsed) {
    return (0, shared_border_style_1.borderStyleToCSSValue)(parsed);
}
/**
 * Parse logical border color property value (border-inline-start-color, border-inline-end-color)
 * Uses the same syntax as individual border color properties
 */
function parseLogicalBorderColorProperty(value) {
    return (0, shared_border_color_1.parseBorderColorProperty)(value);
}
/**
 * Convert logical border color value to CSS string
 */
function logicalBorderColorToCSSValue(parsed) {
    return (0, shared_border_color_1.borderColorToCSSValue)(parsed);
}
